import React from 'react';
import { AmazonCardContainer } from './styled';

function AmazonCard(props) {
  const { data } = props;
  return (
    <AmazonCardContainer className={`box_${data?.id}`}>
      <a href={data?.link}>
        <div className="desktop">
          <div className="content">
            <h3 className="center">{data?.text}</h3>
            <div className="button">
              <p>Buy on Amazon</p>
            </div>
          </div>
          <div className="imageContainer">
            <img src={data?.image} loading="lazy" alt="" />
          </div>
        </div>
        <div className="button">
          <p>Buy on Amazon</p>
        </div>
      </a>
    </AmazonCardContainer>
  );
}

export default AmazonCard;
